export default __webpack_public_path__ + "static/media/CNo.38-2.f7be4e71.jpg";